import axios from "../../config/axiosConfig";
import {
  GSTREGISTER_REPORT_REQUEST,
  GSTREGISTER_REPORT_SUCCESS,
  GSTREGISTER_REPORT_FAILURE,
} from "../types/gst-register-report-types";

export const getGSTRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GSTREGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
    
      const requestParams = { ...defaultParams, ...params };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/gstregister-report/getReport?${queryString}`;
      console.log('Complete GSTREGISTER API Request URL: ', fullUrl);
      return axios.get('/gstregister-report/getReport', { params: requestParams }).then((response) => {
        if (response) {
          dispatch({ 
            type: GSTREGISTER_REPORT_SUCCESS, 
            payload: response 
          });
          console.log("Actions Api Call" , response);
          return response;
        } else {
          throw new Error(response.data?.message || 'Failed to fetch GSTREGISTER report');
        }
      }).catch((error) => {
        console.error("Error fetching GSTREGISTER Report:", error);
        dispatch({ 
          type: GSTREGISTER_REPORT_FAILURE, 
          error: error.response?.data?.message || error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GSTREGISTER Report:", error);
      dispatch({ 
        type: GSTREGISTER_REPORT_FAILURE, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  };
};

export const clearGSTRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: GSTREGISTER_REPORT_SUCCESS, payload: {} });
  }
}
